import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6536259a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right-contents" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "contents-item" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "contents-item-title" }, "商品退款问题"),
    /*#__PURE__*/_createElementVNode("ul", { class: "title-ul" }, [
      /*#__PURE__*/_createElementVNode("li", null, "虚拟商品不支持退款。")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_customer_title = _resolveComponent("customer-title")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_customer_title, { list: _ctx.titleList }, null, 8, ["list"]),
    _hoisted_1
  ], 64))
}